import React from 'react'
import {Flex, ChatBubble} from '/app/src/component'
import { Twemoji } from 'react-emoji-render'
import style from './style.css'


import EntrySelector from '/app/src/model/Entry/selector';


const PreviewStyle = {
    overflow: 'hidden',
    dataName: 'PublicConversation',
    borderRadius: '60px',
    height: '84px',
    width: '100%',
    vAlignContent: 'center',
    userSelect: 'none',
    border: '3px solid transparent',
    cursor: 'pointer',
}

class ConversationPreview extends React.Component {
    constructor(props) {
        super(props);
        // screen = 'normal' -> 'selected' -> 'quick'
        this.state = {
            'onHover': false,
        }
        this._handleOnHover = this._handleOnHover.bind(this);
        this._handleLeaveHover = this._handleLeaveHover.bind(this);
    }

    _handleOnHover(){
        this.setState({
            onHover: true,
        })
    }

    _handleLeaveHover(){
        this.setState({
            onHover: false,
        })
    }

    render() {
        let {title, entry} = this.props
        const currentRoom = this.props.currentRoom;
        const room = this.props.room;
        const active = currentRoom === room? 'PreviewActive': 'Preview';
        const unread = this.props.unread

        let entryBody =  EntrySelector.body(entry) ||  ''
        let entryDateCreated = EntrySelector.detailsDateCreated(entry)

        const employeeName = this.props.employeeName ? this.props.employeeName + ': ' : ''

        return (
            <Flex {...PreviewStyle} border={active?'3px solid #2EA2D2':'3px solid transparent'}>
                <Flex
                    className={style[active]}
                    height='100%'
                    width='100%'
                    onMouseEnter={this._handleOnHover}
                    onMouseLeave={this._handleLeaveHover}
                    >

                    <Flex
                        height="100%"
                        className={style.Preview}
                        hAlignContent='left'
                        vAlignContent='center'
                        basis='100%'
                        >
                        <Flex
                            className={style.PreviewStatus}
                            hAlignContent='center'
                            vAlignContent='center'
                            basis='80px'
                        >
                            <img
                                className={style.PreviewImage}
                                src={'/images/GroupChannel_L@2x.png'}
                                width='50px'
                                height='auto'
                                alt='customer'
                                display='block'
                            />
                            <Flex className={style.IsTypingWrapper}>
                                {this.props.isTyping && <ChatBubble/>}
                            <Flex/>
                            </Flex>
                        </Flex>

                        <Flex grow column>
                            <Flex className={style.PreviewTitle} fontWeight={unread?500:300}>
                                {title}
                            </Flex>
                            <Flex className={style.previewBody} fontWeight={unread?500:300} color={unread?'black': 'darkgrey'}>
                                <div className={style.previewBodyInner} >
                                    {employeeName} <Twemoji text={entryBody}/>
                                </div>
                            </Flex>
                        </Flex>

                        <Flex className={style.previewExtra} basis='20%' column hAlignContent='center'>
                            <Flex center width='30px' height='30px'/>
                            <Flex className={style.DateCreated} fontWeight={unread?500:300}>
                                {entryDateCreated}
                            </Flex>
                        </Flex>
                        <Flex basis='10%'/>
                    </Flex>
                </Flex>
            </Flex>
        );
    }

}

export default ConversationPreview;



// WEBPACK FOOTER //
// ./src/component/Conversation/Preview/PublicConversation.js